const TransportModalityConstant = {
  TRANSPORTER: "TRANSPORTER",
  WORKSHOP: "WORKSHOP",
  STORE: "STORE",
  EXCLUDING_SUPPORT: "EXCLUDING_SUPPORT"
}

export default TransportModalityConstant;
